import { render } from "./InitiativeCard.vue?vue&type=template&id=6253ae0c"
import script from "./InitiativeCard.vue?vue&type=script&lang=js"
export * from "./InitiativeCard.vue?vue&type=script&lang=js"

import "./InitiativeCard.vue?vue&type=style&index=0&id=6253ae0c&lang=css"

import exportComponent from "C:\\Users\\dan51\\PycharmProjects\\misis.club\\change\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__